import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Module1 from "./sections/valuationModule1.section";
import Module2 from "./sections/valuationModule2.section";
import axiosInstance from "../../config/apiInterceptor.config";
import Footer from "../../components/footer/footer.component"
import OutdatedValuation from "../outdated/outdatedValuation.pages";

export const ValuationUDA = () => {
  function getPropertyTypeText(id) {
    switch (id) {
      case 0:
        return "Desconocido";
      case 1:
        return "Ático";
      case 2:
        return "Dúplex";
      case 3:
        return "Chalet";
      case 4:
        return "Apartamento";
      case 5:
        return "Chalet Pareado";
      case 6:
        return "Chalet Adosado";
      case 7:
        return "Estudio";
      case 8:
        return "Villa Rústica";
      case 9:
        return "Habitación";
      case 21:
        return "Uso Mixto";
      case 23:
        return "En Centro Comercial";
      case 24:
        return "Entresuelo";
      case 25:
        return "Sótano";
      case 26:
        return "Otro";
      case 27:
        return "Oficinas";
      case 33:
        return "Plaza de Aparcamiento para Coche";
      case 34:
        return "Plaza de Aparcamiento para Coche y Moto";
      case 35:
        return "Plaza de Aparcamiento para Dos Coches o Más";
      case 36:
        return "Plaza de Aparcamiento Grande para Coche";
      case 37:
        return "Plaza de Aparcamiento Pequeña para Coche";
      case 38:
        return "Terreno Urbano";
      case 39:
        return "A Nivel de la Calle";
      case 40:
        return "Trastero";
      case 41:
        return "Hotel";
      case 42:
        return "Terreno Urbanizable";
      case 43:
        return "Tienda";
      case 44:
        return "Edificio";
      case 45:
        return "Unidad de Oficina";
      case 46:
        return "Almacén";
      case 47:
        return "Fábrica";
      case 48:
        return "Logística";
      case 49:
        return "Apartamento Turístico";
      case 51:
        return "Residencia de Estudiantes";
      case 52:
        return "Residencia Tercera Edad";
      case 53:
        return "Terreno Agrícola";
      case 54:
        return "Terreno Protegido";
      case 55:
        return "Granja";
      case 56:
        return "Nave Industrial Mixta";
      case 57:
        return "Condominio";
      case 58:
        return "Activo Especial";
      case 59:
        return "Garaje";
      default:
        return "No Definido";
    }
  }

  function getBuildStatusText(id) {
    switch (id) {
      case 0:
        return "Desconocido";
      case 1:
        return "Buen estado";
      case 2:
        return "Necesita reforma parcial";
      case 5:
        return "Requiere reforma completa";
      case 6:
        return "A estrenar";
      case 7:
        return "Terminado";
      case 8:
        return "En Construcción";
      default:
        return "No Definido";
    }
  }

  // load data
  const INTEGRATION_URI = process.env.REACT_APP_INTEGRATION_URI
  const [data, setData] = useState();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const iframeKey = searchParams.get("key");
  const valuationId = searchParams.get("valuation_uid");
  const [isValuationOutdated, setValuationOutdated] = useState(false);
  const [isDataReceived, setIsDataReceived] = useState(false);
  const pageRef = useRef(null);

  const getValuationData = async () => {
    await axiosInstance.get(
      `${INTEGRATION_URI}valuation?id=${valuationId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${iframeKey}`,
        },
      }
    ).then(response => {
      if (response.status === 200) {
        setData(response.data);
        setIsDataReceived(true);
      } else {
        setValuationOutdated(true);
      }
    }).catch(error => {
      console.error(error);
    });
  }

  useEffect(() => {
    getValuationData();
  }, [])

  // for aliseda
  useEffect(() => {
    const handleResize = () => {
      const pageHeight = document.body.scrollHeight;
      window.parent.postMessage({ pageHeight: pageHeight }, '*');
    };
  
    // Using ResizeObserver to detect changes in size
    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(document.body);
  
    // Using MutationObserver to detect changes in the DOM structure
    const mutationObserver = new MutationObserver(handleResize);
    mutationObserver.observe(document.body, { attributes: true, subtree: true });
  
    // Cleanup functions
    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, []);
  

  return (
    <main ref={pageRef} className="flex flex-col items-center align-center w-full h-full valuation-container">
      {
        isValuationOutdated ? (
          <OutdatedValuation /> 
        ) : (
              <>
                {
                  data && (
                    <div className="flex flex-col items-center justify-center valuation-main-container">
                <Module1
                  dataUp={isDataReceived}
                  property_type={getPropertyTypeText(data.asset_profile_data.property_type)}
                  address={data.asset_profile_data.address}
                  area={data.asset_profile_data.area}
                  floor={data.asset_profile_data.floor}
                  rooms={data.asset_profile_data.rooms}
                  nbaths={data.asset_profile_data.nbaths}
                  cadastral_ref={data.asset_profile_data.cadastral_bi}
                  lat={data.asset_profile_data.lat}
                  lon={data.asset_profile_data.lon}
                  sale={data.valuation_data.sale}
                  rent={data.valuation_data.rent}
                  sale_secondary_min_price={parseInt(Math.round(data.valuation_data.sale.min_price_m2), 10)}
                  sale_secondary_max_price={parseInt(Math.round(data.valuation_data.sale.max_price_m2), 10)}
                  rent_secondary_min_price={parseInt(Math.round(data.valuation_data.rent.min_price_m2), 10)}
                  rent_secondary_max_price={parseInt(Math.round(data.valuation_data.rent.max_price_m2), 10)}
                  yield_number={data.asset_profile_data.operation === 1 ? data.indicators.sale.yield_rental_avm : data.indicators.rent.yield_rental_avm}
                />
                <Module2
                  indicators={data.indicators}
                  time_to_sale={data.asset_profile_data.operation === 1 ? data.indicators.sale.time_on_market : data.indicators.rent.time_on_market}
                  build_status={getBuildStatusText(data.asset_profile_data.build_status)}
                />
                <Footer />
                    </div>
                  )
                }
              </>
            )
      }

    </main>
  );
};

export default ValuationUDA;
